import { SocialLinkWrap } from './style'

export const SocialLink = ({
  path,
  children,
  title,
  tooltip,
  tooltip_bg,
  tooltip_position,
  color,
  size,
  shape,
  variant,
  space,
  hover,
  ...props
}) => {
  return (
    <SocialLinkWrap
      {...props}
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      $tooltip={tooltip}
      $tooltip_bg={tooltip_bg}
      $tooltip_position={tooltip_position}
      $hastitle={title && !tooltip}
      $color={color}
      $size={size}
      $shape={shape}
      $variant={variant}
      $space={space}
      $hover={hover}
    >
      {children}
      {title && <span className="title">{title}</span>}
    </SocialLinkWrap>
  )
}
